/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { UnmountClosed } from 'react-collapse';
import { css, SerializedStyles } from '@emotion/react';


/**
 * ClamShell: a component that wraps React.Collapse and removes its margins when collapsed.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class ClamShell extends React.PureComponent<{
  isOpen: any;
  springConfig?: { stiffness: number; damping: number; precision: number };
  hasNestedCollapse?: boolean;
  rootCss?: SerializedStyles;
  children: React.ReactNode;
}> {
  public static defaultProps = {
    hasNestedCollapse: false,
  };

  public render = () => (
    <UnmountClosed isOpened={!!this.props.isOpen}
                   springConfig={this.props.springConfig}
                   hasNestedCollapse={this.props.hasNestedCollapse}
                   css={css`
                     ${this.props.rootCss};
                     ${this.props.isOpen ? '' : 'margin: 0 !important;'}
                   `}>
      {this.props.children}
    </UnmountClosed>
  );
}
